import netflix_clone from '../projects_images/netflix_clone.PNG';
import React_color_shades_generator from '../projects_images/React_color_shades_generator.PNG';
import i18n_Project from '../projects_images/i18n_Project.PNG';
import todo_app from '../projects_images/todo_app.PNG';
import socialLogin_with_firebase from '../projects_images/socialLogin_with_firebase.PNG';
import speech_recognition from '../projects_images/speech_recognition.PNG';
import google_Analytics_integration from '../projects_images/google_Analytics_integration.PNG';
import Movies_API_Fetch from '../projects_images/Movies_API_Fetch.PNG';

let projects_store = [
    {
        name: 'NetFlix Clone',
        image: netflix_clone,
        url: 'https://cocky-thompson-b828c8.netlify.app/',
        catagory: ['react.js']
    },
    {
        name: 'React Color Shades Generator',
        image: React_color_shades_generator,
        url: 'https://dazzling-colden-67493c.netlify.app/',
        catagory: ['react.js']
    },
    {
        name: 'i18n Project',
        image: i18n_Project,
        url: 'https://loving-wiles-d5ee5b.netlify.app/',
        catagory: ['react.js']
    },
    {
        name: 'Todo App with firebase',
        image: todo_app,
        url: 'https://todolist-c5551.web.app/',
        catagory: ['react.js', 'firebase']
    },
    {
        name: 'Social login with firebase', 
        image: socialLogin_with_firebase,
        url: 'https://dey-sumit.github.io/NewYear/',
        catagory: ['react.js', 'firebase']
    },
    {
        name: 'Speech Recognition', 
        image: speech_recognition,
        url: 'https://kind-wing-d7770d.netlify.app/',
        catagory: ['javascript']
    },
    {
        name: 'Google Analytics Integration',
        image: google_Analytics_integration,
        url: 'https://nostalgic-leakey-936762.netlify.app/',
        catagory: ['react.js', 'googleAnalytics']
    },
    {
        name: 'Movies API Fetch',
        image: Movies_API_Fetch,
        url: 'https://vigorous-poitras-9cb65c.netlify.app/',
        catagory: ['react.js']
    },{
        name: 'Facebook messenger Integration', 
        image: socialLogin_with_firebase,
        url: 'https://dey-sumit.github.io/NewYear/',
        catagory: ['react.js', 'firebase']
    }
];
export default projects_store;
